import { render } from "./IconTrekSpeeds.vue?vue&type=template&id=1a1a38ea"
import script from "./IconTrekSpeeds.vue?vue&type=script&lang=js"
export * from "./IconTrekSpeeds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__